import { getProvider } from '../svpProvider';
import { getLogger } from '../logger';

import { isSuccessResponse, requestAPI } from './shared/requestAPI';

import type { EditorInput, EditorResponse } from '../../types';

const logger = getLogger('editorsApi');

async function fetchEditors() {
  try {
    const result = await requestAPI<EditorResponse[]>(
      `/${getProvider()}/admin/editors`
    );
    if (isSuccessResponse(result)) {
      return result!;
    }
    throw result;
  } catch (error) {
    logger.error('Failed to fetch editors');
    throw error;
  }
}

async function fetchEditor(editorId: EditorResponse['id']) {
  try {
    const result = await requestAPI<EditorResponse>(
      `/${getProvider()}/admin/editors/${editorId}`
    );
    if (isSuccessResponse(result)) {
      return result!;
    }
    throw result;
  } catch (error) {
    logger.error('Failed to fetch the list of editors');
    throw error;
  }
}

async function createEditor(fields: EditorInput) {
  try {
    const result = await requestAPI<EditorResponse>(
      `/${getProvider()}/admin/editors`,
      {
        method: 'POST',
        body: JSON.stringify(fields),
        headers: { 'Content-Type': 'application/json' },
      }
    );
    if (isSuccessResponse(result)) {
      return result!;
    }
    throw result;
  } catch (error) {
    logger.error('Failed to create editor', { fields });
    throw error;
  }
}

async function updateEditor(
  editorId: EditorResponse['id'],
  fields: Partial<EditorInput>
) {
  try {
    const result = await requestAPI<EditorResponse>(
      `/${getProvider()}/admin/editors/${editorId}`,
      {
        method: 'PATCH',
        body: JSON.stringify(fields),
        headers: { 'Content-Type': 'application/json' },
      }
    );
    if (isSuccessResponse(result)) {
      return result!;
    }
    throw result;
  } catch (error) {
    logger.error('Failed to update editor', { editorId, fields });
    throw error;
  }
}

export { fetchEditors, fetchEditor, createEditor, updateEditor };
